<button
  [type]="type"
  [disabled]="pending || disabled"
  mat-raised-button
  id="smart-btn"
  class="relative pl-3 pr-3 smart-btn w-full"
  [ngClass]="class ? class : ''"
  [class]="lightOrDark"
  [color]="color"
  [attr.data-test]="'smart-button'"
>
  <ng-content></ng-content>
  <div *ngIf="pending" class="pending-layer">
    <mat-spinner
      [color]="lightOrDark === 'dark' ? 'accent' : 'primary'"
      class="ml-1 spinner"
      [diameter]="30"
    ></mat-spinner>
  </div>
</button>
